import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useAppContext } from '../context/AppContext';
import { Check } from 'lucide-react';
export const Results = () => {
  const {
    setCurrentPage,
    timeLeft
  } = useAppContext();
  const [levelWidth, setLevelWidth] = useState(0);
  useEffect(() => {
    // Animate the level bar after mount
    const timer = setTimeout(() => {
      setLevelWidth(68);
    }, 500);
    return () => clearTimeout(timer);
  }, []);
  return <div className="min-h-screen bg-bg pb-16" data-id="element-299">
      <div className="max-w-[720px] mx-auto px-5 pt-7" data-id="element-300">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center pb-4" data-id="element-301">
          <span className="inline-block py-1 px-3.5 rounded-full text-[13px] font-semibold bg-[#E8F5E9] text-[#00C853]" data-id="element-302">
            ✅ Análisis completado
          </span>
          <h1 className="text-[24px] sm:text-[30px] font-extrabold text-dark my-3 leading-[1.3]" data-id="element-303">
            ¡Tu diagnóstico profesional de IA está listo!
          </h1>
        </motion.div>

        {/* Profile Card */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="bg-gradient-to-br from-dark to-[#1a2744] text-white rounded-2xl p-7 mb-5 text-center" data-id="element-304">
          <div className="text-[11px] tracking-[1.5px] uppercase text-gold mb-2" data-id="element-305">
            TU PERFIL IDENTIFICADO:
          </div>
          <div className="text-[22px] font-extrabold mb-5" data-id="element-306">
            Project Manager en Transición Activa
          </div>

          <div className="mb-2" data-id="element-307">
            <div className="flex justify-between text-[11px] opacity-60 mb-1.5" data-id="element-308">
              <span data-id="element-309">Básico</span>
              <span data-id="element-310">Intermedio</span>
              <span data-id="element-311">Avanzado</span>
            </div>
            <div className="bg-white/15 rounded-full h-2.5 relative overflow-hidden" data-id="element-312">
              <div className="h-full rounded-full bg-gradient-to-r from-primary to-gold transition-all duration-1000 ease-out" style={{
              width: `${levelWidth}%`
            }} data-id="element-313" />
            </div>
            <div className="text-[20px] font-bold text-primary mt-2" data-id="element-314">
              68% — Nivel Medio-Alto
            </div>
          </div>
        </motion.div>

        {/* 3 Analysis Cards */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-5" data-id="element-315">
          <div className="bg-[#F0FFF4] rounded-xl p-4 text-[13px]" data-id="element-316">
            <h4 className="text-[#00C853] font-bold mb-2.5 flex items-center gap-1.5" data-id="element-317">
              ✅ A tu favor
            </h4>
            <ul className="space-y-1" data-id="element-318">
              <li className="flex gap-1.5" data-id="element-319">
                <span data-id="element-320">✓</span> Experiencia real en proyectos
              </li>
              <li className="flex gap-1.5" data-id="element-321">
                <span data-id="element-322">✓</span> Base de herramientas digitales
              </li>
              <li className="flex gap-1.5" data-id="element-323">
                <span data-id="element-324">✓</span> Alta motivación
              </li>
              <li className="flex gap-1.5" data-id="element-325">
                <span data-id="element-326">✓</span> Claridad de objetivos
              </li>
            </ul>
          </div>
          <div className="bg-[#FFF8F0] rounded-xl p-4 text-[13px]" data-id="element-327">
            <h4 className="text-primary font-bold mb-2.5 flex items-center gap-1.5" data-id="element-328">
              ⚠️ Tus brechas
            </h4>
            <ul className="space-y-1" data-id="element-329">
              <li className="flex gap-1.5" data-id="element-330">
                <span data-id="element-331">⚠</span> 5-10h/semana en tareas manuales
              </li>
              <li className="flex gap-1.5" data-id="element-332">
                <span data-id="element-333">⚠</span> Sin sistema integrado de IA
              </li>
              <li className="flex gap-1.5" data-id="element-334">
                <span data-id="element-335">⚠</span> Prompt Engineering no aplicado
              </li>
              <li className="flex gap-1.5" data-id="element-336">
                <span data-id="element-337">⚠</span> Sin certificación oficial
              </li>
            </ul>
          </div>
          <div className="bg-[#F0F4FF] rounded-xl p-4 text-[13px]" data-id="element-338">
            <h4 className="text-[#3B5BDB] font-bold mb-2.5 flex items-center gap-1.5" data-id="element-339">
              🎯 Lo que necesitas
            </h4>
            <ul className="space-y-1" data-id="element-340">
              <li className="flex gap-1.5" data-id="element-341">
                <span data-id="element-342">→</span> Método CERTO probado
              </li>
              <li className="flex gap-1.5" data-id="element-343">
                <span data-id="element-344">→</span> Stack IA integrado
              </li>
              <li className="flex gap-1.5" data-id="element-345">
                <span data-id="element-346">→</span> Certificado Europeo
              </li>
              <li className="flex gap-1.5" data-id="element-347">
                <span data-id="element-348">→</span> 30h práctica real
              </li>
            </ul>
          </div>
        </motion.div>

        {/* Metrics Grid */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="grid grid-cols-2 gap-3 mb-5" data-id="element-349">
          <div className="bg-white rounded-xl p-4 text-center shadow-[0_2px_12px_rgba(0,0,0,0.06)]" data-id="element-350">
            <div className="text-[28px] mb-1.5" data-id="element-351">⏰</div>
            <div className="text-[26px] font-extrabold leading-none mb-1 text-primary" data-id="element-352">
              5-10h
            </div>
            <div className="text-[12px] text-textlight leading-[1.4]" data-id="element-353">
              recuperarías por semana con IA
            </div>
          </div>
          <div className="bg-white rounded-xl p-4 text-center shadow-[0_2px_12px_rgba(0,0,0,0.06)]" data-id="element-354">
            <div className="text-[28px] mb-1.5" data-id="element-355">💰</div>
            <div className="text-[26px] font-extrabold leading-none mb-1 text-success" data-id="element-356">
              $3,600+
            </div>
            <div className="text-[12px] text-textlight leading-[1.4]" data-id="element-357">
              valor de tiempo recuperado al año
            </div>
          </div>
          <div className="bg-white rounded-xl p-4 text-center shadow-[0_2px_12px_rgba(0,0,0,0.06)]" data-id="element-358">
            <div className="text-[28px] mb-1.5" data-id="element-359">🎯</div>
            <div className="text-[26px] font-extrabold leading-none mb-1 text-[#3B5BDB]" data-id="element-360">
              90 días
            </div>
            <div className="text-[12px] text-textlight leading-[1.4]" data-id="element-361">
              para lograr tu meta con el plan
            </div>
          </div>
          <div className="bg-white rounded-xl p-4 text-center shadow-[0_2px_12px_rgba(0,0,0,0.06)]" data-id="element-362">
            <div className="text-[28px] mb-1.5" data-id="element-363">🏆</div>
            <div className="text-[18px] font-extrabold leading-none mb-1 text-gold mt-2" data-id="element-364">
              CONFIRMADA ✓
            </div>
            <div className="text-[12px] text-textlight leading-[1.4] mt-2" data-id="element-365">
              Elegibilidad Certificado Europeo
            </div>
          </div>
        </motion.div>

        {/* Transition */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="bg-surface rounded-2xl p-6 text-center mb-5" data-id="element-366">
          <h3 className="text-[20px] font-bold text-dark mb-4" data-id="element-367">
            🎯 Basado en tu perfil, encontramos tu solución:
          </h3>
          <ul className="text-left max-w-[380px] mx-auto mb-5 space-y-1.5" data-id="element-368">
            {['Método probado de IA para proyectos reales', 'Herramientas reales (no teoría)', 'Certificación con validez internacional', 'Aprendizaje a tu ritmo, 100% online'].map((item, i) => <li key={i} className="flex items-center gap-2 text-[15px]" data-id="element-369">
                <span className="shrink-0" data-id="element-370">✅</span>
                <span data-id="element-371">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* Countdown & CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} data-id="element-372">
          <div className="bg-[#B71C1C] text-white rounded-xl py-4 px-5 text-center mb-5" data-id="element-373">
            <p className="text-[13px] mb-1.5 opacity-90" data-id="element-374">
              ⚠️ Tu oferta especial expira en:
            </p>
            <div className="text-[40px] font-extrabold tracking-[4px] leading-none" data-id="element-375">
              {timeLeft}
            </div>
          </div>

          <button onClick={() => setCurrentPage('offer')} className="bg-primary hover:bg-primary-hover text-white border-none rounded-xl py-4 px-8 text-[17px] font-bold cursor-pointer w-full block transition-all duration-200 shadow-primary hover:-translate-y-0.5 mb-2" data-id="element-376">
            👉 VER MI PLAN PERSONALIZADO COMPLETO →
          </button>
          <p className="text-[12px] text-textlight text-center mt-2" data-id="element-377">
            ⚡ Solo disponible por tiempo limitado para perfiles como el tuyo
          </p>
        </motion.div>
      </div>
    </div>;
};